import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';

export const DefaultDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute bottom-[-64px] right-[15%] h-32 w-32 md:right-20 md:top-[-72px] md:h-36 md:w-36"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-airborne absolute bottom-8 right-[38%] hidden md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute bottom-6 left-[25%] md:hidden"
    />
    <DynamicDecorator
      decorator="halfStadium"
      className="absolute right-14 top-[-18px] h-12 w-12 text-gray-100 md:right-[30%] md:top-[-50px] md:h-24 md:w-24"
    />
  </>
);
